import React, { forwardRef } from 'react';
import * as S from './styled';

export const SvgWrapper = forwardRef(
  (
    { children, color, hoverColor, width, height, style = {}, ...rest },
    ref
  ) => (
    <S.Parent
      style={{
        width,
        height,
        ...style,
      }}
      ref={ref}
      noDomColor={color}
      hoverColor={hoverColor}
      {...rest}
    >
      {children}
    </S.Parent>
  )
);
